import { setHours, setMilliseconds, setMinutes, setSeconds } from 'date-fns';
import { fromZonedTime } from 'date-fns-tz';
import addDays from 'date-fns/addDays';
import endOfDay from 'date-fns/endOfDay';

import { ICustomSend } from '../types/campaigns';
import { UTC } from './date';
import { BUSINESS_REASON_ID } from './reasons';

export const DISABLE_SHIPMENT_TRACKING = 'disable_shipment_tracking';

export const INTERNAL_NOTES = 'internal_notes';
export const PRE_CREATED_ENGAGEMENT_ID = 'pre_created_engagement_id';
export const SEND_ON_BEHALF_THE_EMAIL = 'send_on_behalf_the_email';
export const SEND_ON_HOLD = 'on_hold_until';
export const IS_TOGGLE_ON_HOLD_ENABLED = 'is_toggle_on_hold_enabled';
export const CUSTOM_SEND_PRE_CREATED_ENGAGEMENT_ID = 'custom';
export const RECEIVER_REMINDER_INTERVAL = 'receiver_reminder_interval';
export const DELAYED_SHIPPING_EXPIRATION = 'delayed_shipping_expiration';
export const DEFAULT_DELAYED_SHIPPING_EXPIRATION_DATE = fromZonedTime(endOfDay(addDays(new Date(), 60)), UTC);
export const MAX_DELAYED_SHIPPING_EXPIRATION_DATE = addDays(new Date(), 90);
export const MIN_DELAYED_SHIPPING_EXPIRATION_DATE = addDays(new Date(), 1);
export const CAMPAIGN_NAME = 'campaign_name';

export const getDefaultExpirationDate = (): Date => {
  const now = new Date();

  const futureDate = addDays(now, 60);

  return endOfDay(futureDate);
};

export const getDefaultExpirationDateInUTC = (): Date => {
  const now = new Date();

  const futureDate = addDays(now, 60);

  const localEndOfDay = setMilliseconds(setSeconds(setMinutes(setHours(futureDate, 23), 59), 59), 0);

  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return fromZonedTime(localEndOfDay, userTimezone);
};

export const INITIAL_SUMMARY_FORM_STATE = {
  [BUSINESS_REASON_ID]: '',
  [INTERNAL_NOTES]: '',
  [SEND_ON_HOLD]: '',
  [DELAYED_SHIPPING_EXPIRATION]: '',
};

export const EMPTY_CUSTOM_SEND: ICustomSend = {
  name: '',
  description: '',
  box_id: 'custom',
  items: [],
};
